<template>
  <q-dialog
    v-if="reportElement"
    v-model="shown"
  >
    <q-card style="max-width: 800px;">
      <q-card-section class="row items-center q-mx-xs q-gutter-xs full-width no-wrap">
        <div class="text-h6 col ellipsis">
          Edit {{ reportElement.name }}
        </div>
        <q-space />
        <q-btn
          v-close-popup
          class="col-auto"
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <report-controls
          :report-element="reportElement"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import ReportControls from 'src/modules/admin/report/ReportControls'

export default {
  name: 'ReportElementPreviewForm',
  components: {
    ReportControls
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    report: {
      type: Object,
      required: true
    },
    reportElement: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      initializing: null,
      settingControls: []
    }
  },
  computed: {
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    },
    'reportElement.reportOptions': {
      deep: true,
      handler () {
        if (this.initializing) return

        if (this.report.initializing) return

        this.report.runReport()
      }
    }
  },
  methods: {
    async show () {
      this.initializing = true
      this.shown = true

      await this.$nextTick()
      this.initializing = false
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
